import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";

import { RoutesPaths } from "../Router/constant";
import { getAdmins } from "../Services/userService";
import Skeleton from "../Components/SkeletonLoader";

export default function Adminmanagement() {
  const [adminData, setAdminData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [limit] = useState(10);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const userRole = localStorage.getItem("userRole");
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
      setOffset(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);
  useEffect(() => {
    fetchAdmins();
  }, [offset, debouncedSearch]);

  const fetchAdmins = async () => {
    try {
      setLoading(true);

      const response = await getAdmins({
        offset,
        limit,
        search: debouncedSearch,
      });
      console.log("Admins API response:", response?.data);
      const responseData = response?.data?.data ?? response?.data;
      let admins = [];

      if (Array.isArray(responseData?.admins)) {
        admins = responseData.admins;
      } else if (Array.isArray(responseData?.records)) {
        admins = responseData.records;
      } else if (Array.isArray(responseData?.data)) {
        admins = responseData.data;
      } else if (Array.isArray(responseData)) {
        admins = responseData;
      }

      const totalCount =
        responseData?.count ??
        responseData?.total ??
        responseData?.totalCount ??
        responseData?.pagination?.total ??
        admins.length;

      setAdminData(admins);
      setCount(Number(totalCount) || 0);
    } catch (error) {
      console.error("Get admins error:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.data?.message ||
          "Failed to load admins",
      );

      setAdminData([]);
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(count / limit);
  const currentPage = offset;
  const generatePagination = (currentPage, totalPages) => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    if (currentPage <= 3) {
      pages.push(1, 2, 3, "...", totalPages);
    } else if (currentPage >= totalPages - 2) {
      pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, "...", currentPage, "...", totalPages);
    }

    return pages;
  };
  const getAdminName = (admin) => {
    return admin?.fullName || admin?.name || admin?.username || "N/A";
  };
  const handleClearSearch = () => {
    setSearchTerm("");
    setDebouncedSearch("");
    setOffset(1);
  };

  return (
    <div className="container-fluid">
      <div className="row dashboardSection">
        {/* Breadcrumb */}
        <div className="col-md-12">
          <div className="logisticsMenu">
            <p>
              <NavLink to={RoutesPaths.DASHBOARD}>
                <img src="/assets/img/homeIcon.svg" alt="" />
              </NavLink>
            </p>

            <img src="/assets/img/chevron-right.svg" alt="" />

            <p>
              <NavLink
                to={RoutesPaths.ADMINMANAGEMENT}
                style={{
                  cursor: "pointer",
                }}
              >
                Admin management
              </NavLink>
            </p>
          </div>
        </div>

        {/* Admin Table */}
        <div className="col-md-12">
          <div className="bookingDetailsMain bookingManagementMain">
            <div className="bookingDetailsOuter">
              {/* Heading + Create Button */}
              <div className="bookingDetailsAlign">
                <h6 className="bookingDetailsTitle p-0">Admin details</h6>
                 <div
                  style={{
                    position: "relative",
                    width: "320px",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search name or email"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: "100%",
                      height: "42px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "10px 40px 10px 15px",
                      outline: "none",
                      fontSize: "14px",
                    }}
                  />

                  {searchTerm && (
                    <button
                      type="button"
                      onClick={handleClearSearch}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "#777",
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
                {userRole === "admin" && (
                  <NavLink
                    to={RoutesPaths.CREATEADMIN}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <button type="button" className="createOrderBtnDetail">
                      + Create new admin
                    </button>
                  </NavLink>
                )}
              </div>
              {/* Table */}
              <div className="TableOverFlow">
                {/* Table Header */}
                <div className="bookingContent bookingDetailsHeader">
                  {/* Serial Number */}
                  <div className="m-0 orderIdWidth">S.No.</div>

                  {/* Name */}
                  <div className="m-0 userNameWidth">Name</div>

                  {/* Email */}
                  <div className="m-0 logisticswidth">Email</div>

                  {/* Date */}
                  <div className="m-0 statusWidth">Date</div>

                  {/* Action */}
                  <div
                    className="m-0 logisticsActionWidth"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Action
                  </div>
                </div>

                {/* Table Body */}
                <div>
                  {loading ? (
                    /*
                     * Skeleton
                     */
                    [...Array(limit)].map((_, index) => (
                      <div
                        className="bookingContent bookingContentData"
                        key={index}
                      >
                        {/* S.No */}
                        <div className="m-0 orderIdWidth">
                          <Skeleton />
                        </div>

                        {/* Name */}
                        <div className="m-0 userNameWidth">
                          <Skeleton />
                        </div>

                        {/* Email */}
                        <div className="m-0 logisticswidth">
                          <Skeleton />
                        </div>

                        {/* Date */}
                        <div className="m-0 statusWidth">
                          <Skeleton />
                        </div>

                        {/* Action */}
                        <div className="m-0 logisticsActionWidth">
                          <Skeleton />
                        </div>
                      </div>
                    ))
                  ) : adminData.length > 0 ? (
                    /*
                     * Admin data
                     */
                    adminData.map((admin, index) => (
                      <div
                        className="bookingContent bookingContentData"
                        key={admin?._id || index}
                      >
                        {/* Serial Number */}
                        <div className="m-0 orderIdWidth">
                          {(offset - 1) * limit + index + 1}
                        </div>

                        {/* Name */}
                        <div className="m-0 userNameWidth">
                          {getAdminName(admin)}
                        </div>

                        {/* Email */}
                        <div className="m-0 logisticswidth">
                          {admin?.email || "N/A"}
                        </div>

                        {/* Date */}
                        <div className="m-0 statusWidth">
                          {admin?.createdAt
                            ? new Date(admin.createdAt).toLocaleDateString(
                                "en-GB",
                              )
                            : "N/A"}
                        </div>

                        {/* View Action */}
                        <div
                          className="m-0 bookingActionButtons logisticsActionWidth"
                          style={{
                            justifyContent: "center",
                          }}
                        >
                          <NavLink
                            to={`${RoutesPaths.ADMINDETAILS}/${admin?._id}`}
                            state={{ admin }}
                            style={{ textDecoration: "none" }}
                          >
                            <button className="viewMore">View</button>
                          </NavLink>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="noOrders">
                      {debouncedSearch
                        ? "No admin found for your search"
                        : "No admin found"}
                    </p>
                  )}
                </div>
              </div>

              {/* Pagination */}
              {!loading && count > 0 && totalPages > 1 && (
                <div className="paginationSection">
                  {/* Previous */}
                  <p
                    onClick={() => {
                      if (currentPage > 1) {
                        setOffset(currentPage - 1);
                      }
                    }}
                    style={{
                      opacity: currentPage > 1 ? 1 : 0.5,

                      cursor: currentPage > 1 ? "pointer" : "default",
                    }}
                  >
                    &lt;
                  </p>

                  {/* Page Numbers */}
                  {generatePagination(currentPage, totalPages).map(
                    (page, index) =>
                      page === "..." ? (
                        <p key={`dots-${index}`}>...</p>
                      ) : (
                        <p
                          key={page}
                          onClick={() => setOffset(page)}
                          style={{
                            fontWeight:
                              currentPage === page ? "bold" : "normal",

                            cursor: "pointer",
                          }}
                        >
                          {page}
                        </p>
                      ),
                  )}

                  {/* Next */}
                  <p
                    onClick={() => {
                      if (currentPage < totalPages) {
                        setOffset(currentPage + 1);
                      }
                    }}
                    style={{
                      opacity: currentPage < totalPages ? 1 : 0.5,

                      cursor: currentPage < totalPages ? "pointer" : "default",
                    }}
                  >
                    &gt;
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
